//  This is a generated file, do not edit it directly
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgNotification } from '../icons/Notification';

export function NotificationIcon(
  props: Omit<SvgIconProps, 'component' | 'children'>,
): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgNotification} data-qa="NotificationIcon">
      <svg />
    </SvgIcon>
  );
}
